<div class="row">
  <div class="col-lg-12"  >
    <div class="card">
      <div class="card-body">
        <!--<div class="col-sm-12">-->

        <table #dataTable class="display" style="width:100% "></table>

        <button type="button" id="btnLoadList" (click)="getExtAPIconfiguration()" style="display:none">Get</button>
        <button type="button" id="btnDeleteDT" (click)="Delete()" style="display:none">Delete</button>
        <button type="button" id="btnDeleteConfirm" (click)="DeleteConfirm()" style="display:none">Delete Confirm</button>
        <button type="button" id="btn_AddNew" class="btn btn-block btn-primary float-sm-right" (click)="show()" style="display:none">Add New</button>
        <button type="button" id="btnColSave" class="btn btn-block btn-primary float-sm-right" style="display:none">Columns</button>
        <!--</div>-->
        <!-- The Modal -->
        <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-lg">
            <div class="modal-content" id="divStatusCT">

              <!-- Modal Header -->
              <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>

              <!-- Modal body -->

              <div class="modal-body">
                <form #form="ngForm" id="frmExtAPIConf">
                  <div class="row">

                    <div class="col-md-4">
                      <div class="form-group">

                        <label for="ddlApplication">Application<em>*</em></label>
                        <select id="ddlApplication" class="form-control select2">
                          <option></option>
                          <option *ngFor="let item of ApplicationName" value={{item}}>
                            {{item}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="ddlApiName">API Name<em>*</em></label>
                        <select id="ddlApiName" class="form-control select2">
                          <option></option>
                          <option *ngFor="let item of APIname" value={{item}}>
                            {{item}}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="ddlApiMethod">ApiMethod<em>*</em></label>
                        <select id="ddlApiMethod" class="form-control select2">
                          <option></option>
                          <option *ngFor="let item of APImethod" value={{item}}>
                            {{item}}
                          </option>
                        </select>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="txtapiUrl" class="control-label-p">API Url<em>*</em></label>
                      <input class="form-control" type="text" maxlength="250" id="txtapiUrl">
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="txtApiHeaders" class="control-label-p">API Headers</label><em>*</em>
                      <input class="form-control" type="text" maxlength="50" id="txtApiHeaders">
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="txtApiKeyValue" class="control-label-p">API KeyValue</label><em>*</em>
                      <input class="form-control" type="text" maxlength="50" id="txtApiKeyValue">
                    </div>
                  </div>


                  <div class="col-xl-12">
                    <div class="form-group">
                      <label for="txtDescription" class="control-label-p">Description</label><em>*</em>
                      <textarea id="txtDescription" class="form-control" width="200px" cols="15"></textarea>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="txtPayLoad" class="control-label-p">Payload</label><em>*</em>
                      <input class="form-control" type="text" maxlength="250" id="txtPayLoad">
                    </div>
                  </div>


                </form>
              </div>
              <!-- Modal footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="AddExtAPIConfigDetails()" id="btnAdd" [hidden]="isHiddenAdd">Add</button>

                <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="updateExtAPIConfigDetails()" id="btnupdate" [hidden]="isHiddenupdate">Update</button>
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
              </div>
            </div>
            <div id="LoadingImagePopup">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
          <!--</div>
        </div>-->



